import {ngAsync} from '../../utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

export class LandingPageStatsDataService {
    public static serviceName = 'landingPageStatsDataService';

    private static ROUTE= 'stats/landing-page';


    /*@ngInject*/
    constructor(private ajaxService: AjaxService){
    }

    @ngAsync()
    public async get(): Promise<LandingPageParamsWithResult> {
        return this.ajaxService
            .createRequest(LandingPageStatsDataService.ROUTE)
            .get();
    }
}
export interface SingleCountStat {
    count: number;
}

export type LandingPageParamsWithResult = ParamsWithResult<Record<string, SingleCountStat>>

export interface ParamsWithResult<RESULT extends Record<string, any> = Record<string, any>, PARAMS extends Record<string, any> = Record<string, any>> {
    params: PARAMS;
    result: RESULT;
}